import { Component, OnInit, Input } from '@angular/core';
import { MonitorService } from '../../core/services/core.monitor.service';
import { UserService } from '../../core/services/core.user.service';
import { GfTranslateService } from '../../core/services/core.translate.service';

@Component({
  selector: 'gf-monitor',
  template: `<button 
  id="{{buttonId}}"
  type="button" 
  [attr.title]="buttonTitle" 
  name="monitor" 
  [disabled]="!enabled"
  class="btn btn-sm" 
  (click)="toggleMonitor()" 
  data-toggle="button" 
  [ngClass]="{ 'btn-success': monitoring, 'btn-default': !monitoring }">
  
  <span class="glyphicon" 
      [ngClass]="{ 'glyphicon-eye-open': monitoring, 'glyphicon-eye-close': !monitoring }">
  </span>
  
  <span *ngIf="text">
      Monitor
  </span>
</button>`,
})
export class MonitorComponent implements OnInit {
  @Input() section: string;
  @Input() refId: string;
  @Input() text: boolean = false;
  @Input() successOnMsg: string;
  @Input() successOffMsg: string;
  @Input() failureOnMsg: string;
  @Input() failureOffMsg: string;
  @Input() classes: string;

  buttonId: string = '';
  monitoring: boolean = false;
  enabled: boolean = false;
  buttonTitle: string = '';

  constructor(
    private monitorService: MonitorService, 
    private translateService: GfTranslateService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.text = typeof this.text !== 'boolean' ? false : this.text;
    this.monitorService.get(this.section, this.refId).then(() => {
      this.monitorEnabled();
    }).catch(() => {
      this.monitorDisabled();
    });
    this.buttonId = `monitor-${ this.section }-${ this.refId }`;
  }

  toggleMonitor() {
    if (this.monitoring) {
      this.monitorService.unset(this.section, this.refId, this.successOnMsg, this.successOffMsg, this.failureOnMsg, this.failureOffMsg).then(
        () => this.monitorDisabled(),
        () => this.monitorEnabled()
      );
    } else {
      this.monitorService.set(this.section, this.refId, this.successOnMsg, this.successOffMsg, this.failureOnMsg, this.failureOffMsg).then(
        () => this.monitorEnabled(),
        () => this.monitorDisabled()
      );
    }
  }

  monitorEnabled() {
    this.setMonitorState(true);
  }

  monitorDisabled() {
    this.setMonitorState(false);
  }

  setMonitorState(monitoring: boolean) {
    this.monitoring = monitoring;
    this.enabled = this.userService.session.hasUser();

    if (!this.enabled) {
      this.buttonTitle = '';
    } else {
      if (this.monitoring) {
        this.buttonTitle = this.translateService.translate("You are monitoring this object. Click to stop monitoring.");
      } else {
        this.buttonTitle = this.translateService.translate("You are not monitoring this object. Click to start monitoring.");
      }
    }
  }
}
